<script setup lang="ts">
const { t } = useTexts();
const { isUserV2Enabled } = useFeatureFlagsJson();

useSeo({
  title: t('account.history.sports.title'),
});
</script>

<template>
  <UserV2ScreenBetsHistory
    v-if="isUserV2Enabled"
    initial-tab="sports"
  />
  <UserAccountPageLayout
    v-else
    on-back="user-history"
    :title="$t('account.history.sports.title')"
  >
    <div :class="$style.walletTransactions">
      <UserWalletTransactions show-only-this-tab="sports" />
    </div>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.walletTransactions {
  @apply w-full h-auto m-0 max-w-[792px];
}
</style>
